var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"loading"},[_c('v-progress-circular',{attrs:{"size":100,"width":3,"color":"purple","indeterminate":""}}),_c('br'),_c('h2',[_vm._v("Carregando Dashboard")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }